import { render, staticRenderFns } from "./DynamicContainer.vue?vue&type=template&id=b734ea26&"
import script from "./DynamicContainer.vue?vue&type=script&lang=js&"
export * from "./DynamicContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports